import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { InlineHint } from "../../UIToolkit/molecules/InlineHint";
import SystemButton from "../../UIToolkit/SystemButton/SystemButton";

type Props = { onRetry: () => void; dataTestId: string };

/** A Holidays section that couldn't load: says so, with a way to try again. */
export const HolidaySectionError: FC<Props> = ({ onRetry, dataTestId }) => {
	const { t } = useTranslation();
	return (
		<InlineHint
			tone="warning"
			dataTestId={dataTestId}
			action={
				<SystemButton buttonVariant="borderless" size="small" onClick={onRetry} noFullWidthMobile data-testid={`${dataTestId}-retry`}>
					{t("retry")}
				</SystemButton>
			}
		>
			{t("holidays.loadError")}
		</InlineHint>
	);
};
